import { useCallback } from "react";
import { useAuthFetch } from "@/app/hooks/useAuthFetch";
import {
  track as trackAnonymous,
  postServerEvent,
  setPage as setPageRaw,
  identify as identifyRaw,
} from "@/shared/analytics";

// Authenticated-side analytics hook. `track` dual-writes: Clarity custom
// event + Postgres `user_events` row via POST /api/events. `setPage` and
// `identify` stay Clarity-only — they're session tags, not events.
export function useAnalytics() {
  const authFetch = useAuthFetch();

  const track = useCallback(
    (event: string, props?: Record<string, unknown>) => {
      void trackAnonymous(event, props);
      void postServerEvent(authFetch, event, props);
    },
    [authFetch],
  );

  return { track, setPage: setPageRaw, identify: identifyRaw };
}
